import {defineStore} from 'pinia';
import wlClient from '@/plugins/wl-client';
import {useWorkspaceStore} from '@/stores/workspace';

const EXTERNAL_STORE_ID = 'external-store';

export const EXTERNAL_STORE_IDS: string[] = [
  '6a296ce5b5e7d30c2bf2a5b6', // Krumiri Rossi - Casale Monferrato
  '6a76df0d2c8840d998b91545', // Krumiri Rossi - Stabilimento Zona Industriale
];

export const isExternalStoreId = (storeId?: string): boolean =>
  !!storeId && EXTERNAL_STORE_IDS.includes(storeId);

export const useExternalStore = defineStore(EXTERNAL_STORE_ID, {
  getters: {
    isExternalStore(): boolean {
      if (wlClient.getIdentity()?.group === 'admin') {
        return false;
      }
      return isExternalStoreId(useWorkspaceStore().stores[0]?.id);
    },
  },
});
